<template>
  <div id="certify" class="container">
    <div class="swiper-container">
      <div class="swiper-wrapper">
        <div class="swiper-slide" v-for="(val, key) in res" :key="key">
          <div class="t">{{val.title}}</div>
          <a :href="val.link"><img :src="val.url"/></a>
           <div class="describe">{{val.describe}}</div>
        </div>
      </div>
    </div>
      <div class="swiper-pagination" id="hs2-pagination"></div>
  </div>
</template>

<script>
import Swiper from "swiper";
export default {
  name: "banner",
  props:['res'],
  data() {
    return {
      bannerList: [
        { url: require("@/assets/img/banner.png"), link: "" },
        { url: require("@/assets/img/banner.png"), link: "" },
        { url: require("@/assets/img/banner.png"), link: "" },
        { url: require("@/assets/img/banner.png"), link: "" },
        { url: require("@/assets/img/banner.png"), link: "" }
      ]
    };
  },
  created() {},
  methods: {},
  mounted() {
    this.$nextTick(() => {
      setTimeout(()=>{
      var certifySwiper = new Swiper("#certify .swiper-container", {
        watchSlidesProgress: true,
        slidesPerView: "auto",
        centeredSlides: true,
        loop: true,
        loopedSlides: 5,
        autoplay: false,
        // navigation: {
        //   nextEl: "#hs2-next",
        //   prevEl: "#hs2-prev"
        // },
        pagination: {
         // el: "#hs2-pagination"
          //clickable :true,
        },
        on: {
          progress: function(progress) {
            for (var i = 0; i < this.slides.length; i++) {
              var slide = this.slides.eq(i);
              var slideProgress = this.slides[i].progress;
              var modify = 1;
              if (Math.abs(slideProgress) >= 1) {
                modify = (Math.abs(slideProgress) - 1) * 0.3 + 1;
              }
             // console.log(modify);
              
               var scale = 1 - Math.abs(slideProgress) / 3;
              // console.log(Math.abs(1 - Math.abs(slideProgress) / 5) );
              // console.log( slideProgress / 3);
               
              var translate = slideProgress * modify * 260 /2 + "px";
             
              var zIndex = 999 - Math.abs(Math.round(10 * slideProgress));
              slide.transform(
                "translateX(" + translate + ") scale(" + scale + ")"
              );
              slide.css("zIndex", zIndex);
              slide.css("opacity", 1);
              //  if (Math.abs(slideProgress) == 1) {
              //   slide.css("opacity", .7);
              // }
              //  if (Math.abs(slideProgress) == 2 ) {
              //   slide.css("opacity", .5);
              // }
              //  if (Math.abs(slideProgress) == 3 ) {
              //   slide.css("opacity", .3);
              // }
              if (Math.abs(slideProgress) >= 3  ) {
                slide.css("opacity", 0);
              }
            }
          },
          setTransition: function(transition) {
            for (var i = 0; i < this.slides.length; i++) {
              var slide = this.slides.eq(i);
              slide.transition(transition);
            }
          }
        }
      });
      },2000)
    });
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
#certify {
  position: relative;
   width: 100%; 
   overflow: hidden;
  margin: 0 auto;
  background: #ECF3F4;
}

#certify .swiper-container {
  /* width: 70%; */
  width: 100%;
  padding-bottom: 60px;
}

#certify .swiper-slide {
 width: 60%;
 /*	height: 408px;
  height: 408px; */
  background: none;
  /* box-shadow: 0 8px 30px #ddd; */
}
#certify .swiper-slide img {
  display: block;
  width: 100%;
  border-radius: 8px;
}
#certify .swiper-slide p {
  line-height: 98px;
  padding-top: 0;
  text-align: center;
  color: #636363;
  font-size: 1.1em;
  margin: 0;
}

#certify .swiper-pagination {
  width: 100%;
  bottom: 20px;
}

#certify .swiper-pagination-bullets .swiper-pagination-bullet {
  margin: 0 5px;
  border: 3px solid #fff;
  background-color: #d5d5d5;
  width: 10px;
  height: 10px;
  opacity: 1;
}

#certify .swiper-pagination-bullets .swiper-pagination-bullet-active {
  border: 3px solid #00aadc;
  background-color: #fff;
}

/* #certify .swiper-button-prev {
  left: -30px;
  width: 45px;
  height: 45px;
  background: url(../images/wm_button_icon.png) no-repeat;
  background-position: 0 0;
  background-size: 100%;
} */

#certify .swiper-button-prev:hover {
  background-position: 0 -46px;
  background-size: 100%;
}

/* #certify .swiper-button-next {
  right: -30px;
  width: 45px;
  height: 45px;
  background: url(../images/wm_button_icon.png) no-repeat;
  background-position: 0 -93px;
  background-size: 100%;
} */

#certify .swiper-button-next:hover {
  background-position: 0 -139px;
  background-size: 100%;
}
.describe{
  text-align: center;
  margin-top:30px;
   visibility: hidden;
   margin:50px 0 100px;
   font-size: 22px;
}
.t{
  font-size: 38px;
  margin:80px 0 30px;
  text-align: center;
  visibility: hidden;
  font-weight:600;
line-height:24px;
}
.swiper-slide-active{
  .t,.describe{ visibility:initial;}
}
@media (max-width:768px) {
  #certify .swiper-slide img {
  display: block;
  width: 100%;
  border-radius: 8px;
}
.describe{
  text-align: center;
  margin-top:30px;
  margin:20px 0 30px;
  font-size: 14px;
}
#certify .swiper-container {
  /* width: 70%; */
  width: 100%;
  padding-bottom: 0px;
}
.container{
  padding:0 !important;
}
.t{
  font-size: 16px;
  margin:20px 0 10px;
  text-align: center;
}
}
</style>
